// ReactNode can be a JSX element, which has no meaningful string form - only extract the
// primitive parts (used for the plain-text edit box in EditableTag below)
import React from 'react';

export function reactNodeToText(node: React.ReactNode): string {
	if (typeof node === 'string' || typeof node === 'number') return String(node);
	if (Array.isArray(node)) return node.map(reactNodeToText).join('');
	return '';
}
